import React from "react";
import { Link } from 'react-router-dom'
import { Body, BotaoLeft, TopoSeta, Videos } from './style';
import { SiteTopo } from "../topo";
import SetaEsquerda from '../img/Seta_Esquerda.png';

import video01 from './arquivoVideos/video01Konica.mp4';
import video02 from './arquivoVideos/video02Versa.mp4';
import video03 from './arquivoVideos/video03Zebra.mp4';
import video04 from './arquivoVideos/video04Batida.mp4';
import video05 from './arquivoVideos/video05CutLabel.mp4';

const listaVideos = [
    { titulo: 'Impressora Digital', src: video01 },
    { titulo: 'Impressora Digital de Mesa', src: video02 },
    { titulo: 'Impressora de Thermotransferência', src: video03 },
    { titulo: 'Máquina de Corte - Batida', src: video04 },
    { titulo: 'Máquina de Corte - Plotter', src: video05 },
]

export const VideosDigital = () => {

    return (

        <Body>

            <TopoSeta>
                <BotaoLeft>
                    <Link to='/'>
                        <img className="left" src={SetaEsquerda} alt="seta voltar pagina inicial" />
                    </Link>
                </BotaoLeft>
                <SiteTopo />
            </TopoSeta>

            <Videos>
                <div className="painel">

                    <div className="topo">Impressão Digital<br />Equipamentos e Acabamento</div>
                    <hr />

                    <div className="grid-videos">
                        {listaVideos.map((item) => (
                            <div className="videosemlinha" key={item.titulo}>
                                <label>{item.titulo}</label>
                                <div className="video-wrap">
                                    <video className="video" controls>
                                        <source src={item.src} type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </Videos>
        </Body>
    )
}
